import React from 'react';

const EmailTagComponent = ({ email }) => (
  <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
    {email}
  </a>
);

export default EmailTagComponent;
export { EmailTagComponent };
